import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile → /dashboard. */
export const Route = createFileRoute('/profile/')({
  beforeLoad: () => {
    throw redirect({to: '/dashboard'});
  },
});
